import { WitzoChatElement } from './text-widget/chat-widget';
import { WitzoVoiceChat } from './voice-text-widget/root_widget';
import { WitzoVoice } from './voice-widget/voice_widget';

function ensureDefined(name: string, ctor: CustomElementConstructor) {
  if (!customElements.get(name)) {
    customElements.define(name, ctor);
  }
}

/**
 * @description retrieve the url added
 * @returns the url for the hook
 */
const retrieveUrl = () => {
  ensureDefined('witzo-chat', WitzoChatElement);
  const chatWidget: WitzoChatElement = document.querySelector('witzo-chat') as WitzoChatElement;

  if (chatWidget != null) {
    const url = chatWidget.attributes.getNamedItem('api-url')!.nodeValue;

    const primaryTextNode = chatWidget.attributes.getNamedItem('primary-text');
    const text = primaryTextNode ? primaryTextNode.nodeValue : null;

    const botColorNode = chatWidget.attributes.getNamedItem('bot-color');
    const bot_color = botColorNode ? botColorNode.nodeValue : null;

    const sendColorNode = chatWidget.attributes.getNamedItem('send-color');
    const send_color = sendColorNode ? sendColorNode.nodeValue : null;

    const floatingBtnColorNode = chatWidget.attributes.getNamedItem('floating-btn');
    const floatingBtn = floatingBtnColorNode ? floatingBtnColorNode.nodeValue : null;

    const logoIconNode = chatWidget.attributes.getNamedItem('logo-icon');
    const logoIcon = logoIconNode ? logoIconNode.nodeValue : null;

    const bannerTextNode = chatWidget.attributes.getNamedItem('banner-text');
    const bannerText = bannerTextNode ? bannerTextNode.nodeValue : null;

    const chatHeaderNode = chatWidget.attributes.getNamedItem('banner-color');
    const chatHeader = chatHeaderNode ? chatHeaderNode.nodeValue : null;

    const autoOpenNode = chatWidget.attributes.getNamedItem('auto-open');
    const autoOpen = autoOpenNode ? autoOpenNode.nodeValue : null;

    const userChatColor = chatWidget.attributes.getNamedItem('user-chat-color');
    const userChatColorValue = userChatColor ? userChatColor.nodeValue : null;

    const bannerTextColorNode = chatWidget.attributes.getNamedItem('banner-text-color');
    const bannerTextColor = bannerTextColorNode ? bannerTextColorNode.nodeValue : null;

    const closeButtonColorNode = chatWidget.attributes.getNamedItem('close-button-color');
    const closeButtonColor = closeButtonColorNode ? closeButtonColorNode.nodeValue : null;
    const uniqueIdNode = chatWidget.attributes.getNamedItem('uniqueId');
    const uniqueId = uniqueIdNode ? uniqueIdNode.nodeValue : null;
    const apiBaseUrlNode = chatWidget.attributes.getNamedItem('api-base-url');
    const apiBaseUrl = apiBaseUrlNode ? apiBaseUrlNode.nodeValue : null;

    const bannerTextParagraphNode = chatWidget.attributes.getNamedItem('banner-text-paragraph');
    const bannerTextParagraph = bannerTextParagraphNode ? bannerTextParagraphNode.nodeValue : null;

    const bannerTextParagraphColorNode = chatWidget.attributes.getNamedItem('banner-text-paragraph-color');
    const bannerTextParagraphColor = bannerTextParagraphColorNode ? bannerTextParagraphColorNode.nodeValue : null;

    chatWidget.chatUrl = url ?? '';
    chatWidget.defaultPrimaryText = text ?? '';
    chatWidget.botBackgroundColor = bot_color ?? '';
    chatWidget.sendBackgroundColor = send_color ?? '';
    chatWidget.floatingButtonColor = floatingBtn ?? '';
    chatWidget.bannerText = bannerText ?? '';
    chatWidget.logoIcon = logoIcon ?? '';
    chatWidget.chatHeader = chatHeader ?? '';
    chatWidget.autoOpen = autoOpen === 'true' ? true : false;
    chatWidget.userChatColor = userChatColorValue ?? '';
    chatWidget.bannerTextColor = bannerTextColor ?? '';
    chatWidget.closeButtonColor = closeButtonColor ?? '';
    chatWidget.uniqueId = uniqueId ?? '';
    chatWidget.apiBaseURL = apiBaseUrl ?? '';
    chatWidget.bannerTextParagraph = bannerTextParagraph ?? '';
    chatWidget.bannerTextParagraphColor = bannerTextParagraphColor ?? '';
    return;
  }

  ensureDefined('witzo-voice', WitzoVoice);
  //if chat widget is added then it will be shown nothing else
  const voiceWidget: WitzoVoice = document.querySelector('witzo-voice') as WitzoVoice;

  if (voiceWidget) {
    const agentId = voiceWidget.attributes.getNamedItem('agent-id')!.nodeValue;
    voiceWidget.assignAgentId = agentId ?? '';
    return;
  }

  ensureDefined('witzo-voice-chat', WitzoVoiceChat);

  const voiceChatWidget: WitzoVoiceChat = document.querySelector(
    'witzo-voice-chat'
  ) as WitzoVoiceChat;
  if (voiceChatWidget) {
    const url = voiceChatWidget.attributes.getNamedItem('api-url')!.nodeValue;
    const agentIdNode = voiceChatWidget.attributes.getNamedItem('agent-id');
    const agentId = agentIdNode ? agentIdNode.nodeValue : null;

    const primaryTextNode = voiceChatWidget.attributes.getNamedItem('primary-text');
    const text = primaryTextNode ? primaryTextNode.nodeValue : null;

    const botColorNode = voiceChatWidget.attributes.getNamedItem('bot-color');
    const bot_color = botColorNode ? botColorNode.nodeValue : null;

    const sendColorNode = voiceChatWidget.attributes.getNamedItem('send-color');
    const send_color = sendColorNode ? sendColorNode.nodeValue : null;

    const floatingBtnColorNode = voiceChatWidget.attributes.getNamedItem('floating-btn');
    const floatingBtn = floatingBtnColorNode ? floatingBtnColorNode.nodeValue : null;

    const chatVoiceChatColorNode = voiceChatWidget.attributes.getNamedItem('chat-voice-icon-color');
    const chatVoiceChatColor = chatVoiceChatColorNode ? chatVoiceChatColorNode.nodeValue : null;

    const uniqueIdNode = voiceChatWidget.attributes.getNamedItem('unique-id');
    const uniqueId = uniqueIdNode ? uniqueIdNode.nodeValue : null;
    const apiBaseUrlNode = voiceChatWidget.attributes.getNamedItem('api-base-url');
    const apiBaseUrl = apiBaseUrlNode ? apiBaseUrlNode.nodeValue : null;

    const logoIconNode = voiceChatWidget.attributes.getNamedItem('logo-icon');
    const logoIcon = logoIconNode ? logoIconNode.nodeValue : null;

    const bannerTextNode = voiceChatWidget.attributes.getNamedItem('banner-text');
    const bannerText = bannerTextNode ? bannerTextNode.nodeValue : null;

    const chatHeaderNode = voiceChatWidget.attributes.getNamedItem('banner-color');
    const chatHeader = chatHeaderNode ? chatHeaderNode.nodeValue : null;

    const userChatColorNode = voiceChatWidget.attributes.getNamedItem('user-chat-color');
    const userChatColor = userChatColorNode ? userChatColorNode.nodeValue : null;

    const bannerTextColorNode = voiceChatWidget.attributes.getNamedItem('banner-text-color');
    const bannerTextColor = bannerTextColorNode ? bannerTextColorNode.nodeValue : null;

    const closeButtonColorNode = voiceChatWidget.attributes.getNamedItem('close-button-color');
    const closeButtonColor = closeButtonColorNode ? closeButtonColorNode.nodeValue : null;

    const bannerTextParagraphNode = voiceChatWidget.attributes.getNamedItem('banner-text-paragraph');
    const bannerTextParagraph = bannerTextParagraphNode ? bannerTextParagraphNode.nodeValue : null;

    const bannerTextParagraphColorNode = voiceChatWidget.attributes.getNamedItem('banner-text-paragraph-color');
    const bannerTextParagraphColor = bannerTextParagraphColorNode ? bannerTextParagraphColorNode.nodeValue : null;

    const defaultLanguageNode =
      voiceChatWidget.attributes.getNamedItem('default-language') ||
      voiceChatWidget.attributes.getNamedItem('language') ||
      voiceChatWidget.attributes.getNamedItem('chat-language');
    const defaultLanguage = defaultLanguageNode ? defaultLanguageNode.nodeValue : null;

    voiceChatWidget.chatInfo = {
      url: url ?? '',
      apiBaseUrl: apiBaseUrl,
      defaultText: text,
      botColor: bot_color,
      sendColor: send_color,
      floatingBtn: floatingBtn,
      iconColor: chatVoiceChatColor,
      uniqueId: uniqueId,
      bannerText: bannerText,
      bannerTextColor: bannerTextColor,
      chatHeader: chatHeader,
      logoIcon: logoIcon,
      closeButtonColor: closeButtonColor,
      userChatColor: userChatColor,
      bannerTextParagraph: bannerTextParagraph,
      bannerTextParagraphColor: bannerTextParagraphColor,
      defaultLanguage: defaultLanguage,
    };

    const iconColorNode = voiceChatWidget.attributes.getNamedItem('voice-send-button');
    const voiceColor = iconColorNode ? iconColorNode.nodeValue : null;

    voiceChatWidget.voiceInfo = {
      agentId: agentId ?? '',
      iconColor: voiceColor,
      apiUrl: url ?? '',
      apiBaseUrl: apiBaseUrl ?? '',
      uniqueId: uniqueId ?? '',
      bannerText: bannerText,
      bannerTextColor: bannerTextColor,
      chatHeader: chatHeader,
      logoIcon: logoIcon,
      closeButtonColor: closeButtonColor,
      bannerTextParagraph: bannerTextParagraph,
      bannerTextParagraphColor: bannerTextParagraphColor,
    };
    return;
  }
};

retrieveUrl();
